import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import Tooltip from "@material-ui/core/Tooltip";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import FormGroup from "@material-ui/core/FormGroup";
import Divider from "@material-ui/core/Divider";
import TableHead from "@material-ui/core/TableHead";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ViewCheckPopup from "../components/ViewCheckPopup";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import { getErrorString } from "../display/ErrorStrings";
import ReactImageMagnify from "react-image-magnify";

import ZoomIcon from "@material-ui/icons/ZoomInOutlined";
import ViewBackIcon from "@material-ui/icons/YoutubeSearchedForOutlined";
import DeselectIcon from "@material-ui/icons/BackspaceOutlined";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
});

class ItemDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      historyErrorString: "",
      historyData: [],
      renderImage: false,
      imageZoom: false,
      backImagePopup: false,
    };
    this.onClose = this.onClose.bind(this);
    this.onClosePopup = this.onClosePopup.bind(this);
  }

  componentDidMount() {
    this.loadHistory();
    this.loadImage();
  }

  onClose(e) {
    e.preventDefault();
    this.props.onClosePopup(e);
  }

  onClosePopup(e) {
    this.setState({ imageZoom: false });
    this.setState({ backImagePopup: false });
  }

  loadHistory() {
    var date = "";
    var amount = "";
    if (
      this.props.item.status.includes("Issue") ||
      this.props.item.status.includes("Void") ||
      this.props.item.status.includes("Stop")
    ) {
      date = this.props.item.issueDate;
      amount = this.props.item.issueAmount;
    } else {
      date = this.props.item.paidDate;
      amount = this.props.item.paidAmount;
    }
    fetch(this.getUrl("on_item_history_request"), {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
        transit: this.props.accountObject.transit,
        account: this.props.accountObject.account,
        checkNumber: this.props.item.checkNumber,
        trace: this.props.item.trace,
        date: date,
        amount: amount,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          if (reply.error) {
            this.setState({ historyErrorString: reply.errorString });
          } else {
            this.setState({ historyData: reply.history });
          }
        }
      })
      .catch((error) => {
        this.setState({
          historyErrorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  loadImage() {
    let dateC = "",
      amountC = "";
    if (
      this.props.item.status.includes("Issue") ||
      this.props.item.status.includes("Void") ||
      this.props.item.status.includes("Stop")
    ) {
      dateC = this.props.item.issueDate;
      amountC = this.props.item.issueAmount;
    } else {
      dateC = this.props.item.paidDate;
      amountC = this.props.item.paidAmount;
    }

    fetch(this.getUrl("on_check_image_request"), {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
        transit: this.props.accountObject.transit,
        account: this.props.accountObject.account,
        checkNumber: this.props.item.checkNumber,
        trace: this.props.item.trace,
        date: dateC,
        amount: amountC,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          this.setState({ renderImage: true });
        }
      })
      .catch((error) => {
        this.setState({ renderImage: true });
      });
  }

  handleZoom(e) {
    this.setState({ imageZoom: true });
  }

  handleBackImage(e) {
    let dateC = "";
    let amountC = "";
    if (
      this.props.item.status.includes("Issue") ||
      this.props.item.status.includes("Void") ||
      this.props.item.status.includes("Stop")
    ) {
      dateC = this.props.item.issueDate;
      amountC = this.props.item.issueAmount;
    } else {
      dateC = this.props.item.paidDate;
      amountC = this.props.item.paidAmount;
    }
    let myUrl = this.getUrl("on_check_image_request", this.state.item);
    //myUrl += '&back=yes';
    fetch(myUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
        transit: this.props.accountObject.transit,
        account: this.props.accountObject.account,
        checkNumber: this.props.item.checkNumber,
        trace: this.props.item.trace,
        date: dateC,
        amount: amountC,
        back: "yes",
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          this.setState({ backImagePopup: true });
        }
      })
      .catch((error) => {
        this.setState({ backImagePopup: true });
      });
  }

  getUrl(requestType) {
    return requestType;
    /*if(this.props.item.status.includes('Issue') || this.props.item.status.includes('Void') || this.props.item.status.includes('Stop'))
		{
			let myUrl = requestType + '?transit=' +
				this.props.accountObject.transit +
				'&account=' + this.props.accountObject.account +
				'&checkNumber=' + encodeURIComponent(this.props.item.checkNumber) +
				'&trace=' + encodeURIComponent(this.props.item.trace) +
				'&date=' + encodeURIComponent(this.props.item.issueDate) +
				'&amount=' + encodeURIComponent(this.props.item.issueAmount) +
				'&r=' + new Date().getTime() +
				'&token=' + this.props.secureToken;
				return myUrl;
		}
		else{
			let myUrl = requestType + '?transit=' +
				this.props.accountObject.transit +
				'&account=' + this.props.accountObject.account +
				'&checkNumber=' + encodeURIComponent(this.props.item.checkNumber) +
				'&trace=' + encodeURIComponent(this.props.item.trace) +
				'&date=' + encodeURIComponent(this.props.item.paidDate) +
				'&amount=' + encodeURIComponent(this.props.item.paidAmount) +
				'&r=' + new Date().getTime() +
				'&token=' + this.props.secureToken;
				return myUrl;
		}*/
  }

  render() {
    const { classes } = this.props;
    let { t } = this.props;
    let data = this.state.historyData;
    let imgUrl = "img/src" + new Date().getTime() + ".png"+ "?secureToken=" + this.props.secureToken;
    return (
      <div>
        {this.state.imageZoom && (
          <ViewCheckPopup
            zoom={true}
            regular={false}
            onClosePopup={this.onClosePopup}
            url={"img/src" + new Date().getTime() + ".png"+ "?secureToken=" + this.props.secureToken}
          />
        )}
        {this.state.backImagePopup && (
          <ViewCheckPopup
            zoom={true}
            regular={false}
            onClosePopup={this.onClosePopup}
            url={"img/back" + new Date().getTime() + ".png"+ "?secureToken=" + this.props.secureToken}
          />
        )}

        <Paper elevation={5}>
          <FormGroup row>
            <Typography variant="headline" color="textSecondary">
              &nbsp;&nbsp; {this.props.item.status}
              &nbsp;&nbsp;
            </Typography>
            <Button onClick={this.onClose} color="primary">
              <DeselectIcon />
              &nbsp;{t("deselect.button")}
            </Button>
          </FormGroup>
          <Divider />
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            stickyHeader
          >
            <TableHead>
              <TableRow>
                <TableCell style={{ width: "10%" }}>
                  {t("transit.header")}
                </TableCell>
                <TableCell style={{ width: "10%" }}>
                  {t("account.header")}
                </TableCell>
                <TableCell style={{ width: "10%" }}>
                  {t("checkNumber.header")}
                </TableCell>
                <TableCell style={{ width: "10%" }}>
                  {t("status.header")}
                </TableCell>
                <TableCell style={{ width: "10%" }}>
                  {t("presentedDate.header")}
                </TableCell>
                <TableCell style={{ width: "10%" }}>
                  {t("issueDate.header")}
                </TableCell>
                <TableCell style={{ width: "10%" }}>
                  {t("presented.header")}
                </TableCell>
                <TableCell style={{ width: "10%" }}>
                  {t("issue.header")}
                </TableCell>
                <TableCell style={{ width: "20%" }}>
                  {t("payee.header")}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow key={1}>
                <TableCell style={{ width: "10%" }}>
                  {this.props.accountObject.transit}
                </TableCell>
                <TableCell style={{ width: "10%" }}>
                  {this.props.accountObject.account}
                </TableCell>
                <TableCell style={{ width: "10%" }}>
                  {this.props.item.checkNumber}
                </TableCell>
                <TableCell style={{ width: "10%" }}>
                  {this.props.item.status}
                </TableCell>
                <TableCell style={{ width: "10%" }}>
                  {this.props.item.paidDate}
                </TableCell>
                <TableCell style={{ width: "10%" }}>
                  {this.props.item.issueDate}
                </TableCell>
                <TableCell style={{ width: "10%" }} numeric={true}>
                  {this.props.item.paidAmount}
                </TableCell>
                <TableCell style={{ width: "10%" }} numeric={true}>
                  {this.props.item.issueAmount}
                </TableCell>
                <TableCell style={{ width: "20%" }}>
                  {this.props.item.payee}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Paper>
        <p> &nbsp;&nbsp;{t("history.label")}&nbsp;&nbsp;</p>
        {this.state.historyErrorString.length > 0 && (
          <h3 style={{ color: "red" }}> {this.state.historyErrorString} </h3>
        )}
        {this.state.historyErrorString.length === 0 && (
          <Paper elevation={5}>
            <List dense={false}>
              {data.map((n) => {
                return (
                  <ListItem>
                    <ListItemText primary={n} secondary={null} />
                  </ListItem>
                );
              })}
            </List>
          </Paper>
        )}
        {this.state.renderImage &&
          !(
            this.props.item.status.includes("Issue") ||
            this.props.item.status.includes("Void") ||
            this.props.item.status.includes("Stop")
          ) && (
            <div>
              <FormGroup row>
                <p> &nbsp;&nbsp;{t("checkImage.label")}&nbsp;&nbsp;</p>
                <Tooltip title={t("zoom.tip")}>
                  <Button
                    color="primary"
                    onClick={(event) => this.handleZoom(event)}
                  >
                    <ZoomIcon />
                    &nbsp;{t("zoom.button")}
                  </Button>
                </Tooltip>
                <Tooltip title={t("viewBack.tip")}>
                  <Button
                    color="primary"
                    onClick={(event) => this.handleBackImage(event)}
                  >
                    <ViewBackIcon />
                    &nbsp;{t("viewBack.button")}
                  </Button>
                </Tooltip>
              </FormGroup>
              <ReactImageMagnify
                {...{
                  smallImage: {
                    alt: "Not Available",
                    width: 768,
                    height: 328,
                    src: imgUrl,
                  },
                  largeImage: {
                    src: imgUrl,
                    width: 2304,
                    height: 981,
                  },
                }}
              />
            </div>
          )}
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(ItemDetails));
